/* eslint-disable */
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
// chakra imports
import { Box, Flex, HStack, Text, useColorModeValue } from "@chakra-ui/react";
import { MdExpandLess, MdExpandMore } from "react-icons/md";

export function SidebarLinks(props) {
  //   Chakra color mode
  let location = useLocation();
  let activeColor = useColorModeValue("gray.700", "white");
  let inactiveColor = useColorModeValue(
    "secondaryGray.600",
    "secondaryGray.600"
  );
  let activeIcon = useColorModeValue("brand.500", "white");
  let textColor = useColorModeValue("secondaryGray.500", "white");
  let brandColor = useColorModeValue("brand.500", "brand.400");

  const { routes } = props;
  const [openCategories, setOpenCategories] = React.useState({});

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routePath) => {
    const fullPath = `/admin${routePath}`;
    if (fullPath.includes(":")) {
      const routePattern = fullPath.replace(/:[^/]+/g, "[^/]+");
      const regex = new RegExp(`^${routePattern.replace(/\//g, "\\/")}$`);
      return regex.test(location.pathname);
    }
    return location.pathname === fullPath || location.pathname.startsWith(`${fullPath}/`);
  };

  const categoryHasActiveRoute = (categoryRoute) => {
    if (!categoryRoute?.items?.length) return false;
    return categoryRoute.items.some((item) => {
      if (item.category) return categoryHasActiveRoute(item);
      if (!item.path) return false;
      return activeRoute(item.path.toLowerCase());
    });
  };

  const isCategoryOpen = (categoryKey, categoryRoute) => {
    if (openCategories[categoryKey] !== undefined) {
      return openCategories[categoryKey];
    }
    return categoryHasActiveRoute(categoryRoute);
  };

  // this function creates the links from the secondary accordions (for example auth -> sign-in -> default)
  const createLinks = (routes, parentKey = "root", level = 0) => {
    return routes.map((route, index) => {
      if (route.category) {
        const categoryKey = `${parentKey}-${route.name}-${index}`;
        const isOpen = isCategoryOpen(categoryKey, route);
        const isActiveCategory = categoryHasActiveRoute(route);

        return (
          <Box key={categoryKey}>
            <Flex
              align='center'
              justify='space-between'
              onClick={() =>
                setOpenCategories((prev) => ({
                  ...prev,
                  [categoryKey]: !isOpen,
                }))
              }
              cursor='pointer'
              ps={{
                sm: `${10 + level * 12}px`,
                xl: `${16 + level * 12}px`,
              }}
              pe='10px'
              pt={level === 0 ? '18px' : '10px'}
              pb='12px'>
              <HStack spacing='10px'>
                {route.icon ? (
                  <Box color={isActiveCategory ? activeIcon : textColor}>{route.icon}</Box>
                ) : null}
                <Text
                  fontSize={level === 0 ? 'sm' : 'sm'}
                  color={isActiveCategory ? activeColor : textColor}
                  fontWeight={isActiveCategory ? '700' : '600'}>
                  {route.name}
                </Text>
              </HStack>
              <Box color={textColor}>
                {isOpen ? <MdExpandLess /> : <MdExpandMore />}
              </Box>
            </Flex>
            {isOpen && createLinks(route.items, categoryKey, level + 1)}
          </Box>
        );
      } else if (
        route.layout === "/admin" &&
        !route.hidden
      ) {
        return (
          <NavLink key={index} to={route.layout + route.path}>
            {route.icon ? (
              <Box>
                <HStack
                  spacing={
                    activeRoute(route.path.toLowerCase()) ? "22px" : "26px"
                  }
                  py='5px'
                  ps={`${10 + level * 18}px`}>
                  <Flex w='100%' alignItems='center' justifyContent='center'>
                    <Box
                      color={
                        activeRoute(route.path.toLowerCase())
                          ? activeIcon
                          : textColor
                      }
                      me={level > 0 ? '12px' : '18px'}>
                      {route.icon}
                    </Box>
                    <Text
                      fontSize={level > 0 ? 'sm' : 'md'}
                      me='auto'
                      color={
                        activeRoute(route.path.toLowerCase())
                          ? activeColor
                          : textColor
                      }
                      fontWeight={
                        activeRoute(route.path.toLowerCase())
                          ? "bold"
                          : "normal"
                      }>
                      {route.name}
                    </Text>
                  </Flex>
                  <Box
                    h='36px'
                    w='4px'
                    bg={
                      activeRoute(route.path.toLowerCase())
                        ? brandColor
                        : "transparent"
                    }
                    borderRadius='5px'
                  />
                </HStack>
              </Box>
            ) : (
              <Box>
                <HStack
                  spacing={
                    activeRoute(route.path.toLowerCase()) ? "22px" : "26px"
                  }
                  py='5px'
                  ps={`${10 + level * 18}px`}>
                  <Text
                    fontSize={level > 0 ? 'sm' : 'md'}
                    me='auto'
                    color={
                      activeRoute(route.path.toLowerCase())
                        ? activeColor
                        : inactiveColor
                    }
                    fontWeight={
                      activeRoute(route.path.toLowerCase()) ? "bold" : "normal"
                    }>
                    {route.name}
                  </Text>
                  <Box
                    h='36px'
                    w='4px'
                    bg={
                      activeRoute(route.path.toLowerCase())
                        ? brandColor
                        : "transparent"
                    }
                    borderRadius='5px'
                  />
                </HStack>
              </Box>
            )}
          </NavLink>
        );
      }
    });
  };
  //  BRAND
  return createLinks(routes);
}

export default SidebarLinks;
